export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12142.171a56a1.jpg";